"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var spinner_gif_1 = require("./spinner.gif");
var Loader = function () { return React.createElement("img", { src: spinner_gif_1.default, alt: "Loader" }); };
exports.default = Loader;
//# sourceMappingURL=loader.js.map